import React from 'react';
import { PropsWithChildren } from 'react';
import { PageProps } from 'gatsby';
import { LanguageContext } from 'contexts/LanguageContext';
import { useSiteMetadata } from 'hooks/useSiteMetadata';
import { SupportedLanguages } from 'models/languages';

const PageRoot = ({
  children,
  pageContext,
}: PropsWithChildren<Omit<PageProps<unknown, { lang: SupportedLanguages }>, 'children'>>) => {
  const { defaultLanguage } = useSiteMetadata();

  return (
    <LanguageContext.Provider value={pageContext.lang ?? defaultLanguage}>
      {children}
    </LanguageContext.Provider>
  );
};

export default PageRoot;
